import React, { useState } from 'react';
import styled from 'styled-components';
import { POCValue } from 'screens/student-details/styled-comps';
import { Row, FlexView, COLORS, toRGBA } from '@cuemath/comps';
import { Text, Button as WCButton } from '@cuemath/web-comps';

import { postStudentTransferStatus } from 'actions/student-transfer/single-student';
import { stCreatedByDummyId } from 'constants/student-transfer';
import { getDateOfRequest } from 'utils/student-transfer';

import { getCookie } from 'utils';

const Root = styled(FlexView)`
  gap: 16px;
  padding: 8px 0px;
`;

const InfoWrapper = styled(FlexView)`
  width: 320px;
  gap: ${({ gap }) => gap || '16'}px;
`;

const NameCardWrapper = styled(Row)`
  gap: 16px;
  margin-top: ${({ marginTop }) => marginTop};
`;

const NameCard = styled(Text)`
  min-width: 152px;
  line-height: 20px;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 1px;
  width: auto;
  font-weight: 700;
`;

const Button = styled(WCButton)`
  width: 100%;
  height: 48px;
`;

const getParentUnhappyData = data => {
  const {
    studentName,
    teacherName,
    newTeacherName,
    grade,
    region,
    classBalance,
    tenureEndDate,
    firstClassTakenOn,
  } = data || {};

  return [
    {
      title: 'Student',
      value: studentName,
    },
    {
      title: 'Teacher',
      value: teacherName,
    },
    {
      title: 'New Teacher',
      value: newTeacherName,
    },
    {
      title: 'Grade',
      value: grade,
    },
    {
      title: 'Region',
      value: region,
    },
    {
      title: 'Class Balance',
      value: classBalance,
    },
    {
      title: 'Tenure end date',
      value: getDateOfRequest(tenureEndDate) || '-',
    },
    {
      title: 'First class taken on',
      value: firstClassTakenOn,
    },
  ];
};

const STParentUnhappy = ({ data }) => {
  const {
    assigningSingleStudent,
    studentId,
    reasonForTransfer,
    regularSlots,
    courseStream,
  } = data || {};
  const userId = getCookie('user_id') || getCookie('emp_id');

  const parentUnhappyData = getParentUnhappyData(data);
  const [errorMessage, setErrorMessage] = useState('');
  const [didAssign, setDidAssign] = useState(false);

  const onStudentTransferCompletion = error => {
    if (error) {
      setErrorMessage(errorMessage);
    } else {
      setDidAssign(true);
      if (typeof assigningSingleStudent === 'function') {
        assigningSingleStudent();
      }
    }
  };

  const { post: initiateStudentTransfer, isProcessing } = postStudentTransferStatus({
    onComplete: onStudentTransferCompletion,
  });

  const findAndAssignMathTeacher = () => {
    const finalData = {
      created_by_id: userId || stCreatedByDummyId,
      reason: reasonForTransfer,
      schedules: regularSlots,
    };

    if (reasonForTransfer === 'PREFERRED_TEACHER') {
      finalData.course_stream = courseStream;
    }

    initiateStudentTransfer(finalData, studentId);
  };

  const message = typeof errorMessage !== 'string' ? errorMessage?.reason : errorMessage;

  return (
    <Root>
      <InfoWrapper>
        {parentUnhappyData.map(item => {
          const { title, value } = item || {};

          return (
            <NameCardWrapper key={title} alignItems="center">
              <NameCard variant="eyebrow2" color={toRGBA(COLORS.COLA, 0.75)}>
                {title}
              </NameCard>
              <POCValue variant="cta1">{value || '-'}</POCValue>
            </NameCardWrapper>
          );
        })}
      </InfoWrapper>

      <Button
        isBusy={isProcessing}
        onClick={findAndAssignMathTeacher}
        label="Find and assign teacher"
        isDisabled={didAssign}
      />
      {message && (
        <Text color={COLORS.RED_SHADE} variant="eyebrow2">
          {message}
        </Text>
      )}
    </Root>
  );
};

export default STParentUnhappy;
